import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { MatPageable, PageableResponse } from '@core/table/mat-table';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { buildQueryString } from '@shared/util/util';
import { DomainCacheService } from './domain-cache.service';

const baseRef = 'entidade';
const baseRefSuperior = 'entidade-superior';
const route = {
  insert: `${baseRef}`,
  edit: `${baseRef}`,
  consultar: `${baseRef}/consultar`,
  consultarId: (id: any) => `${baseRef}/consultar/${id}`,
  consultarIdBasico: (id: any) => `${baseRef}/consultar/${id}/basico`,
  getTipoEntidadeById: (id: any) => `${baseRef}/tipo-entidade/${id}`,
  entidadeSuperiorComboEntidade: `${baseRef}/entidade-superior-combo`,
  entidadeSuperiorCombo: `${baseRefSuperior}/entidade-superior-combo`,
  entidadeSuperior: `${baseRefSuperior}`,
  entidadeSuperiorPaginado: `${baseRefSuperior}/entidade-superior-combo-paginado`,
  entidadeCombo: `${baseRef}/entidade-combo`,
  entidadeComboPaginado: `${baseRef}/entidade-combo-paginado`,
  entidadePertenceCombo: `${baseRef}/entidade-pertence-combo`,
  entidadeRepresentacaoNacional: `${baseRef}/entidade-representacao-nacional`,
  entidadeRepresentanteCombo: (id: any) => `${baseRef}/entidade-representada-combo/${id}`,
  entidadeRepresentanteList: `${baseRef}/entidade-representada-combo`,
  entidadeRepresentadaComboPaginado: `${baseRef}/entidade-representada-combo-paginado`,
  entidadeAfinsCombo: `${baseRef}/entidade-afins-combo`,
  entidadeAdministradora: `${baseRef}/entidade-administradora-combo`,
  entidadeAssociada: `${baseRef}/entidade-associada-combo`,
  // consultarCombo: `${baseRef}/consultar-combo`,
  // salvar: `${baseRef}/registrar`,
  // buscarPorid: (id: number) => `${baseRef}/${id}`,
  // editar: (id: number) => `${baseRef}/${id}`,
  alterarstatus: `${baseRef}/alterar-status`,
  statusEntidade: `${baseRef}/status-entidade`,
  entidadeMudancaCombo: `${baseRef}/entidade-mudanca-combo`,
  listarPorFederacaoCombo: `${baseRef}/entidade-federacao-combo`,
  listarEntidadeCargo: (idEntidade: any) => `${baseRef}/entidade-cargo/combo/${idEntidade}`,
  listarEntidadesSuperior: (idEntidade: any) => `entidade-superior/entidadeId/${idEntidade}`,
  insertEntidadesSuperior: `${baseRefSuperior}/salvar`,
  editEntidadesSuperior: (idEstrutura: any) =>  `${baseRefSuperior}/editar/${idEstrutura}`,
  deleteEntidadesSuperior: (idEstrutura: any) => `${baseRefSuperior}/remover/${idEstrutura}`,

  perfilAprovador: (idPerfil: any) => `usuarios/perfil/${idPerfil}`,
  listarEntidadeMultiplaCargo: `entidade-cargo/combo`,

  listarEntidadesVinculadasGrupoEconomico: (idGrupoEconomico: any) => `${baseRef}/entidade-combo/grupo-economico/${idGrupoEconomico}`,
  editarEntidadesVinculadasGrupoEconomico: `${baseRef}/grupo-economico/alterar-entidade`,
}

@Injectable({
  providedIn: 'root'
})
export class EntidadesService {

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private domainCache: DomainCacheService
  ) { }

  consultar(filtro: any, page: MatPageable, ignoreLoading = false) {
    return this.apiService.post<PageableResponse<any>>(
      `${route.consultar}${page.query}`,
      this.apiService.removeNullPropertys(filtro),
      undefined,
      undefined,
      ignoreLoading
    );
  }

  consultarSort(filtro: any, page: MatPageable, params: any, ignoreLoading = false) {
    const queryString = buildQueryString({...params });
    const fullUrl = `${route.consultar}${page.query}${queryString}`;
    return this.apiService.post<PageableResponse<any>>(
      fullUrl,
      this.apiService.removeNullPropertys(filtro),
      undefined,
      undefined,
      ignoreLoading
    );
  }

  consultarId(id: any, ignoreLoading = false): Observable<PageableResponse<any>> {
    return this.apiService.get<PageableResponse<any>>(`${route.consultarId(id)}`, undefined, undefined, ignoreLoading);
  }

  consultarIdBasico(id: any): Observable<PageableResponse<any>> {
    return this.apiService.get<PageableResponse<any>>(`${route.consultarIdBasico(id)}`);
  }

  getTipoEntidadeById(id: any): Observable<PageableResponse<any>> {
    const key = `entidade/tipo-entidade/${id}`;
    return this.domainCache.getOrLoad(key, () =>
      this.apiService.get<PageableResponse<any>>(`${route.getTipoEntidadeById(id)}`, undefined, undefined, true)
    );
  }

  // entidadeSuperior(): Observable<any> {
  //   return this.apiService.get<any>(`${route.entidadeSuperiorCombo}`);
  // }

  entidadeCombo(): Observable<any> {
    return this.domainCache.getOrLoad('entidade/entidade-combo', () =>
      this.apiService.get<any>(`${route.entidadeCombo}`, undefined, undefined, true)
    );
  }

  entidadeComboPaginado(termo: string): Observable<any> {
    return this.apiService.get<any>(`${route.entidadeComboPaginado}/${termo}`, undefined, undefined, true);
  }

  entidadeAfinsCombo(): Observable<any> {
    return this.apiService.get<any>(`${route.entidadeAfinsCombo}`, undefined, undefined, true);
  }

  entidadeSuperiorCombo(): Observable<any> {
    return this.apiService.get<any>(`${route.entidadeSuperiorCombo}`, undefined, undefined, true);
  }

  entidadeRepresentacaoNacional(): Observable<any> {
    return this.apiService.get<any>(`${route.entidadeRepresentacaoNacional}`, undefined, undefined, true);
  }

  entidadePertenceCombo(): Observable<any> {
    return this.apiService.get<any>(`${route.entidadePertenceCombo}`, undefined, undefined, true);
  }

  entidadeRepresentanteList(): Observable<any> {
    return this.apiService.get<any>(`${route.entidadeRepresentanteList}`, undefined, undefined, true);
  }

  entidadeRepresentadaComboPaginado(termo: string): Observable<any> {
    return this.apiService.get<any>(`${route.entidadeRepresentadaComboPaginado}/${termo}`, undefined, undefined, true);
  }

  getEntidadeSuperiores() {
    return this.apiService.get(`${route.entidadeSuperior}`)
  }
  entidadeAdministradora() {
    return this.apiService.get(`${route.entidadeAdministradora}`)
  }
  entidadeAssociada(filtro: any) {
    return this.apiService.post(`${route.entidadeSuperior}`, filtro)
  }
  getEntidadeSuperiorList(filtro: any) {
    return this.apiService.get<any>(`${route.entidadeSuperiorPaginado}/${filtro}`);

  }

  salvar(obj: any) {
    return this.apiService.post(`${route.insert}`, obj).pipe(
      tap(() => this.invalidarCombosEntidade())
    );
  }

  editar(obj: any) {
    return this.apiService.put(`${route.edit}`, obj).pipe(
      tap(() => this.invalidarCombosEntidade())
    );
  }

  private invalidarCombosEntidade(): void {
    this.domainCache.invalidate('entidade/entidade-combo');
  }

  alterarStatus(obj: any) {
    return this.apiService.put(`${route.alterarstatus}`, obj)
  }

  statusEntidade() {
    return this.apiService.get(`${route.statusEntidade}`)
  }

  entidadeMudancaCombo() {
    return this.apiService.get<any>(`${route.entidadeMudancaCombo}`)
  }

  listarPorFederacaoCombo() {
    return this.apiService.get<any>(`${route.listarPorFederacaoCombo}`, undefined, undefined, true)
  }

  listarEntidadeCargo(idEntidade: any) {
    return this.apiService.get<any>(`${route.listarEntidadeCargo(idEntidade)}`, undefined, undefined, true);
  }

  listarEntidadeMultiplaCargo(obj: any) {
    return this.apiService.post<any>(route.listarEntidadeMultiplaCargo, obj);
  }


  consultarEntidadesSuperior(idEntidade: any, page: MatPageable): Observable<PageableResponse<any>> {
    return this.apiService.get<PageableResponse<any>>(`${route.listarEntidadesSuperior(idEntidade)}${page.query}`);
  }

  consultarSortEntidadesSuperior(idEntidade: any, page: MatPageable, params: any) {
      const queryString = buildQueryString({ ...params });
      const fullUrl = `${route.listarEntidadesSuperior(idEntidade)}${page.query}${queryString}`;
      return this.apiService.get<PageableResponse<any>>(
        fullUrl,
        this.apiService.removeNullPropertys(idEntidade)
      );
    }

  salvarEntidadesSuperior(obj: any) {
    return this.apiService.post(`${route.insertEntidadesSuperior}`, obj)
  }

  editarEntidadesSuperior(obj: any) {
    return this.apiService.put(`${route.editEntidadesSuperior(obj.id)}`, obj)
  }

  deleteEntidadesSuperior(obj: any) {
    return this.apiService.delete(`${route.deleteEntidadesSuperior(obj.id)}`, obj)
  }

  entidadeRepresentanteCombo(id: any) {
    return this.apiService.get<any>(`${route.entidadeRepresentanteCombo(id)}`, undefined, undefined, true);
  }

  perfilAprovador(perfil: any) {
    return this.apiService.get<any>(`${route.perfilAprovador(perfil)}`)
  }

  entidadesSemGrupoEconomico(): Observable<any> {
    return this.apiService.get<any>(`${route.entidadeCombo}`);
  }

  listarEntidadesVinculadasGrupoEconomico(idGrupoEconomico: any) {
    return this.apiService.get<any>(`${route.listarEntidadesVinculadasGrupoEconomico(idGrupoEconomico)}`)
  }

  editarEntidadesVinculadasGrupoEconomico(obj: any) {
    return this.apiService.put(route.editarEntidadesVinculadasGrupoEconomico, obj)
  }
}
